const rightSideBetsValues = ['O', 'U', '*'];

export const Big9GetCombination = (outcomes) => {
    let objectKeys = Object.keys.length > 0 ? Object.keys(outcomes) : null;
    const selections = {};

    if (objectKeys !== null) {
        const res = objectKeys.map((item) => {
            let marks = outcomes[item].marks;
            let isContainOver = marks.includes(rightSideBetsValues[0]);
            let isContainUnder = marks.includes(rightSideBetsValues[1]);
            let isContainWildCard = marks.includes(rightSideBetsValues[2]);

            const incompleteCombs = !(
                ['1', 'X', '2'].some((r) => marks.includes(r)) &&
                ['O', 'U'].some((r) => marks.includes(r))
            );

            selections[item] = [];

            if (incompleteCombs && !isContainWildCard) {
                selections[item].push(...marks);
            } else if (isContainWildCard) {
                selections[item].push(`${rightSideBetsValues[2]}`);
            } else {
                marks.map((bet) => {
                    if (bet === '1' && isContainOver) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[0]}`
                        );
                    }
                    if (bet === 'X' && isContainOver) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[0]}`
                        );
                    }
                    if (bet === '2' && isContainOver) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[0]}`
                        );
                    }
                    if (bet === '1' && isContainUnder) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[1]}`
                        );
                    }
                    if (bet === 'X' && isContainUnder) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[1]}`
                        );
                    }
                    if (bet === '2' && isContainUnder) {
                        selections[item].push(
                            `${bet}/${rightSideBetsValues[1]}`
                        );
                    }
                });
            }

            if (selections[item].length === 0) {
                delete selections[item];
            }

            let status = {};
            if (outcomes[item].status) {
                status = { status: outcomes[item].status };
                // status = { status: 'CANCELED' };
            }
            return {
                marks: selections[item] || [],
                eventName: outcomes[item].eventName,
                nr: parseInt(item),
                ...status,
            };
        });
        return res;
    }
};
